import type { FlowEventEmitter } from '@redviking/argonaut-core-ui/src/applet/design/flows/editor-composition/useFlowEvents';
import type { FlowNodeControl } from './FlowNodeControl';
import type { BaseNodeCfg, FlowCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';

export function getControlEventHandlers (opts: {
    controlKey: string;
    controlOpts: FlowNodeControl.WideOpts | null;
    target: 'controlValue' | 'input' | 'output';
    flowEventEmitter: FlowEventEmitter;
    nodeCfg: BaseNodeCfg;
    flowCfg: FlowCfg;
}) {
    const { controlOpts } = opts;

    if (!controlOpts) {
        return {};
    }
    // set the default control listeners, which just update the controlValue or socket default
    const controlListeners: Record<string, (value: unknown, opts: {
        nodeCfg: BaseNodeCfg;
        flowEventEmitter: FlowEventEmitter;
        flowCfg: FlowCfg;
        controlKey: string;
        target: 'controlValue' | 'input' | 'output';
    }) => void> = {};

    // apply spec defined control event handlers (if any) on top of the default
    for (const [ eventKey, eventHandler ] of Object.entries(controlOpts.on || {})) {
        if (eventHandler) {
            controlListeners[eventKey] = payload => {
                eventHandler(payload, {
                    flowEventEmitter: opts.flowEventEmitter,
                    nodeCfg: opts.nodeCfg,
                    flowCfg: opts.flowCfg,
                    controlKey: opts.controlKey,
                    target: opts.target,
                });
            };
        }
    }
    return controlListeners;
}

export function defaultControlUpdateValueHandler<T, NODE_CFG extends BaseNodeCfg> (value: T, opts: {
    nodeCfg: NODE_CFG;
    flowEventEmitter: FlowEventEmitter;
    flowCfg: FlowCfg;
    controlKey: string;
    target: 'controlValue' | 'input' | 'output';
}) {
    const newNodeCfg = {
        ...opts.nodeCfg,
    };

    if (opts.target === 'controlValue') {
        newNodeCfg.controlValues = {
            ...newNodeCfg.controlValues,
            [opts.controlKey]: value,
        };
    } else if (opts.target === 'input') {
        newNodeCfg.socketDefaults = {
            ...newNodeCfg.socketDefaults || {},
            inputs: {
                ...newNodeCfg.socketDefaults?.inputs,
                [opts.controlKey]: value,
            },
        };
    } else if (opts.target === 'output') {
        newNodeCfg.socketDefaults = {
            ...newNodeCfg.socketDefaults || {},
            outputs: {
                ...newNodeCfg.socketDefaults?.outputs,
                [opts.controlKey]: value,
            },
        };
    }

    opts.flowEventEmitter.emit('updateNodeCfg', { newNodeCfg });
}
